import '../../icons/grunticon.json';

export default class {
}
